import { createAction, props } from '@ngrx/store';

import { prefixed } from '../../../shared/utils/factory.utils';

const whatsNew = prefixed('[WhatsNew]');

export const WhatsNewActions = {
  checkWhatsNew: createAction(whatsNew('Check whats new')),
  checkWhatsNewSucceeded: createAction(whatsNew('Check whats new succeeded'), props<{ shouldShow: boolean }>()),
  checkWhatsNewFailed: createAction(whatsNew('Check whats new failed'), props<{ error: unknown }>()),

  openWhatsNew: createAction(whatsNew('Open whats new')),

  nextWhatsNewStep: createAction(whatsNew('Next step')),
  previousWhatsNewStep: createAction(whatsNew('Previous step')),

  dismissWhatsNew: createAction(whatsNew('Dismiss whats new')),
  dismissWhatsNewSucceeded: createAction(whatsNew('Dismiss whats new succeeded')),
  dismissWhatsNewFailed: createAction(whatsNew('Dismiss whats new failed'), props<{ error: unknown }>()),
};
